import CircularProgress from "@material-ui/core/CircularProgress";
import moment from "moment-timezone";
import React, { Component } from "react";
import { DragDropContext } from "react-beautiful-dnd";
import FinishedDialog from "../../components/FinishedDialog";
import Schedule from "../../components/schedule/Schedule";
import UpgradeDialog from "../../components/UpgradeDialog";
import ColorsDivisions from "../../constants/colors_divisions";
import ColorsGroups from "../../constants/colors_groups";
import defaultFases from "../../constants/DefaultFases";
import defaultMatchTimes from "../../constants/DefaultMatchTimes";
import { languages } from "../../constants/languages";
import { checkRefereeWishMaxMatches } from "../../util/CheckRefereeWishMaxMatches";
import { getMatchDuration } from "../../util/GetMatchDuration";
import { getTeamName } from "../../util/GetTeamName";
import { groupBy } from "../../util/GroupBy";

class ScheduleContainer extends Component {
  state = {
    matches: [],
    matchesByKey: {},
    matchesLoaded: false,
    pouleOptions: [],
    bracketPoules: [],
    allPoules: [],
    poulesByKey: {},
    poulesLoaded: false,
    bracketOptions: [],
    subBrackets: {},
    bracketsByKey: {},
    bracketsLoaded: false,
    resultSpotsAll: [],
    resultSpotsLoaded: false,
    matchesTemp: undefined,
    referees: [],
    refereesByKey: {},
    refereesLoaded: false,
    selectedDay: "0",
    days: [],
    daysByKey: {},
    daysLoaded: false,
    oneSecondPassed: false,
    finishedDialogOpen: false,
    selectedSportPark: "0",
    sportParks: [],
    sportParksByKey: {},
    sportParksLoaded: false,
    selected: [],
    fieldsTemp: undefined,
    isDraggingRefereeFromMatch: "",
    isDraggingReferee: "",
    sideSheetExpanded: true,
    sideSheetExpandedMobile: false,
    isDraggingRefereeMaxMatchesWish: false,
    teams: [],
    teamsByKey: {},
    teamsLoaded: false,
    players: [],
    playersByKey: {},
    playersLoaded: false,
    upgradeDialogOpen: false,
    selectedRoundFilter: "all",
    teamSearch: "",
  };

  handleSelectRoundChange = (e) => {
    this.setState({ selectedRoundFilter: e.target.value });
  };

  toggleUpgradeDialog = () => {
    this.setState({
      upgradeDialogOpen: !this.state.upgradeDialogOpen,
    });
  };

  handleSideSheetExpandClick = () => {
    if (this.props.supportOpen) {
      this.props.handleDrawerClose();
      this.setState((state) => ({
        sideSheetExpanded: true,
        sideSheetExpandedMobile: false,
      }));
    } else {
      this.setState((state) => ({
        sideSheetExpanded: !state.sideSheetExpanded,
        sideSheetExpandedMobile: !state.sideSheetExpandedMobile,
      }));
    }
  };

  handleSelectChange = (e, value) => {
    this.setState({ selected: value });
  };

  toggleFinishedDialog = () => {
    this.setState({ finishedDialogOpen: !this.state.finishedDialogOpen });
  };

  selectDay = (dayId) => {
    this.setState({ selectedDay: dayId });
  };

  selectSportPark = (sportParkId) => {
    this.setState({ selectedSportPark: sportParkId });
  };

  handleTeamSearch = (event) => {
    this.setState({ teamSearch: event.target.value });
  };

  UNSAFE_componentWillMount = () => {
    this.timeout = setTimeout(() => {
      this.setState({ oneSecondPassed: true });
    }, 500);
    const tournamentRef = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);

    this.unsubscribeMatches = tournamentRef
      .collection("matches")
      .onSnapshot((querySnapshot) => {
        let matches = [];
        let matchesByKey = {};
        querySnapshot.forEach(function (doc) {
          let match = doc.data();
          if (match.day === undefined) {
            match["day"] = "0";
          }
          match["id"] = doc.id;
          matches.push(match);
          matchesByKey[doc.id] = match;
        });

        this.setState({
          matches: matches,
          matchesByKey: matchesByKey,
          matchesLoaded: true,
          matchesTemp: undefined,
        });
      });

    this.unsubscribePoules = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("poules")
      .onSnapshot((querySnapshot) => {
        let poules = [];
        let bracketPoules = [];
        let poulesByKey = {};
        let allPoules = [];
        querySnapshot.forEach((doc) => {
          let poule = doc.data();
          let division = this.props.divisionsObject[poule.division] || {};
          poule["id"] = doc.id;
          poule["value"] = doc.id;
          poule["label"] =
            poule.name +
            " - " +
            ((division.fases || defaultFases)[poule.fase] || {}).name;
          if (this.props.divisions.length > 1) {
            poule["labelDivision"] = division.name;
            poule["labelLong"] = poule.label + " - " + division.name;
          }
          if (!poule.bracket) {
            poules.push(poule);
          } else {
            bracketPoules.push(poule);
          }
          poulesByKey[doc.id] = doc.data();
          allPoules.push(poule);
        });
        // poules.sort((a, b) => a.num - b.num);
        this.setState({
          pouleOptions: poules,
          bracketPoules: bracketPoules,
          poulesByKey: poulesByKey,
          poulesLoaded: true,
          allPoules: allPoules,
        });
      });

    this.unsubscribeBrackets = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("brackets")
      .onSnapshot((querySnapshot) => {
        let brackets = [];
        let bracketsByKey = {};
        querySnapshot.forEach((doc) => {
          let bracket = doc.data();
          let division = this.props.divisionsObject[bracket.division] || {};
          bracket["isBracket"] = true;
          bracket["id"] = doc.id;
          bracket["value"] = doc.id;
          bracket["label"] =
            bracket.name +
            " - " +
            ((division.fases || defaultFases)[bracket.fase] || {}).name;
          if (this.props.divisions.length > 1) {
            bracket["labelDivision"] = division.name;
            bracket["labelLong"] = bracket.label + " - " + division.name;
          }
          brackets.push(bracket);
          bracketsByKey[doc.id] = doc.data();
        });
        // brackets.sort((a, b) => a.num - b.num);
        this.setState({
          bracketOptions: brackets,
          bracketsByKey: bracketsByKey,
          bracketsLoaded: true,
        });
      });

    this.unsubscribeResultSpots = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("resultSpots")
      .onSnapshot((querySnapshot) => {
        let resultSpotsAll = [];
        querySnapshot.forEach((doc) => {
          let resultSpot = doc.data();
          resultSpot["id"] = doc.id;
          resultSpot["resultSpot"] = true;
          resultSpotsAll.push(resultSpot);
        });
        this.setState({
          resultSpotsAll: resultSpotsAll,
          resultSpotsLoaded: true,
        });
      });

    this.unsubscribeReferees = tournamentRef
      .collection("referees")
      .onSnapshot((querySnapshot) => {
        let referees = [];
        let refereesByKey = {};
        querySnapshot.forEach(function (doc) {
          let referee = doc.data();
          referee["id"] = doc.id;
          referees.push(referee);
          refereesByKey[doc.id] = referee;
        });

        this.setState({
          referees: referees,
          refereesByKey: refereesByKey,
          refereesLoaded: true,
        });
      });

    this.unsubscribeDays = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("days")
      .onSnapshot((querySnapshot) => {
        let days = [];
        let daysObj = {};
        querySnapshot.forEach((doc) => {
          let day = doc.data();
          day["id"] = doc.id;
          days.push(day);
          daysObj[doc.id] = doc.data();
        });
        this.setState({
          days: days.sort((a, b) => a.date - b.date),
          daysByKey: daysObj,
          daysLoaded: true,
        });
      });

    this.unsubscribeSportparks = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("sportParks")
      .onSnapshot((querySnapshot) => {
        let sportParks = [];
        let sportParksObj = {};
        querySnapshot.forEach((doc) => {
          let sportPark = doc.data();
          sportPark["id"] = doc.id;
          sportParks.push(sportPark);
          sportParksObj[doc.id] = sportPark;
        });
        let sportParksSorted = sportParks.sort((a, b) => {
          if (a.num > b.num) {
            return 1;
          } else if (a.num < b.num) {
            return -1;
          }
          if (a.id > b.id) {
            return 1;
          } else if (a.id < b.id) {
            return -1;
          } else {
            return 0;
          }
        });
        let newState = {
          sportParks: sportParksSorted,
          sportParksByKey: sportParksObj,
          sportParksLoaded: true,
        };
        if (!this.state.sportParksLoaded) {
          newState["selectedSportPark"] = (sportParksSorted[0] || {}).id || "0";
        }
        this.setState(newState);
      });

    this.unsubscribeTeams = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("teams")
      .onSnapshot((querySnapshot) => {
        let teams = [];
        let teamsByKey = {};
        querySnapshot.forEach((doc) => {
          let team = doc.data();
          team["id"] = doc.id;
          let division = this.props.divisionsObject[team.division] || {};
          if (this.props.divisions.length > 1) {
            team["labelDivision"] = division.name || "";
          }
          team["label"] = team.name || "";
          team["value"] = doc.id;
          teams.push(team);
          teamsByKey[doc.id] = doc.data();
        });
        this.setState({
          teams: teams,
          teamsByKey: teamsByKey,
          teamsLoaded: true,
        });
      });

    this.unsubscribePlayers = tournamentRef
      .collection("players")
      .onSnapshot((querySnapshot) => {
        let players = [];
        let playersByKey = {};
        querySnapshot.forEach((doc) => {
          let player = doc.data();
          player["id"] = doc.id;
          players.push(player);
          playersByKey[doc.id] = player;
        });
        this.setState({
          players: players,
          playersByKey: playersByKey,
          playersLoaded: true,
        });
      });
  };

  componentWillUnmount = () => {
    clearTimeout(this.timeout);
    this.unsubscribeMatches();
    this.unsubscribePoules();
    this.unsubscribeBrackets();
    this.unsubscribeResultSpots();
    this.unsubscribeReferees();
    this.unsubscribeDays();
    this.unsubscribeSportparks();
    this.unsubscribeTeams();
  };

  onDragEnd = (result) => {
    let teamElements = document.getElementsByClassName("bothTeamElement");
    for (var i = 0; i < teamElements.length; i++) {
      let element = teamElements[i];
      element.style.fontWeight = "normal";
      element.style.textDecoration = "";
    }
    let allTeamElements = document.getElementsByClassName("teamElement");
    for (var c = 0; c < allTeamElements.length; c++) {
      let element = allTeamElements[c];
      element.style.fontWeight = "";
      element.style.textDecoration = "";
    }
    let teamElementsBreak = document.getElementsByClassName("teamElementbreak");
    for (var r = 0; r < teamElementsBreak.length; r++) {
      let element = teamElementsBreak[r];
      element.style.fontWeight = "normal";
      element.style.textDecoration = "";
    }
    let refereeElements = document.getElementsByClassName("hoverItemReferee");
    for (var x = 0; x < refereeElements.length; x++) {
      let element = refereeElements[x];
      element.style.fontWeight = "normal";
      element.style.textDecoration = "";
    }
    if (result.type === "REFEREE") {
      this.setState({
        isDraggingRefereeFromMatch: "",
        isDraggingReferee: "",
      });
      if (result.destination) {
        const db = window.firebase.firestore();
        const tournamentRef = db
          .collection("tournaments")
          .doc(this.props.tournament[".key"]);
        let toUpdate = {};
        let batch = db.batch();
        let sourceMatchId = result.source.droppableId;
        let destinationMatchId = result.destination.droppableId;

        let matchesCopy = JSON.parse(JSON.stringify(this.state.matches));
        // this.state.matches.forEach(m => {
        //   matchesCopy.push({});
        // });

        if (sourceMatchId !== "referees") {
          let sourceMatch = this.state.matchesByKey[sourceMatchId];

          let referees = [];
          if (sourceMatch.referee) {
            referees.push(sourceMatch.referee);
          }
          if (sourceMatch.referee2) {
            referees.push(sourceMatch.referee2);
          }
          if (sourceMatch.referee3) {
            referees.push(sourceMatch.referee3);
          }
          if (sourceMatch.referee4) {
            referees.push(sourceMatch.referee4);
          }
          if (sourceMatch.referee5) {
            referees.push(sourceMatch.referee5);
          }
          referees.splice(result.source.index, 1);
          let toUpdateSource = {};
          toUpdateSource["referee"] = referees[0] || "";
          toUpdateSource["referee2"] = referees[1] || "";
          toUpdateSource["referee3"] = referees[2] || "";
          toUpdateSource["referee4"] = referees[3] || "";
          toUpdateSource["referee5"] = referees[4] || "";

          let sourceMatchCopy =
            matchesCopy.find((m) => m.id === sourceMatchId) || {};
          sourceMatchCopy["referee"] = referees[0] || "";
          sourceMatchCopy["referee2"] = referees[1] || "";
          sourceMatchCopy["referee3"] = referees[2] || "";
          sourceMatchCopy["referee4"] = referees[3] || "";
          sourceMatchCopy["referee5"] = referees[4] || "";
          batch.update(
            tournamentRef.collection("matches").doc(result.source.droppableId),
            toUpdateSource
          );
        }

        if (destinationMatchId !== "refereesBack") {
          let match = this.state.matchesByKey[destinationMatchId] || {};

          let destinationIndex = result.destination.index;
          let referees = [];
          if (match.referee) {
            referees.push(match.referee);
          }
          if (match.referee2) {
            referees.push(match.referee2);
          }
          if (match.referee3) {
            referees.push(match.referee3);
          }
          if (match.referee4) {
            referees.push(match.referee4);
          }
          if (match.referee5) {
            referees.push(match.referee5);
          }
          if (sourceMatchId === destinationMatchId) {
            if (referees[result.source.index]) {
              referees.splice(result.source.index, 1);
            }
          }
          referees.splice(destinationIndex, 0, result.draggableId.slice(0, 20));
          toUpdate["referee"] = referees[0] || "";
          toUpdate["referee2"] = referees[1] || "";
          toUpdate["referee3"] = referees[2] || "";
          toUpdate["referee4"] = referees[3] || "";
          toUpdate["referee5"] = referees[4] || "";

          let destinationMatchCopy =
            matchesCopy.find((m) => m.id === destinationMatchId) || {};
          destinationMatchCopy["referee"] = referees[0] || "";
          destinationMatchCopy["referee2"] = referees[1] || "";
          destinationMatchCopy["referee3"] = referees[2] || "";
          destinationMatchCopy["referee4"] = referees[3] || "";
          destinationMatchCopy["referee5"] = referees[4] || "";
          batch.update(
            tournamentRef.collection("matches").doc(destinationMatchId),
            toUpdate
          );
        }

        let breaksCopy = Object.keys(this.props.tournament.breaks || {}).map(
          (key, i) => {
            let tournamentBreak = this.props.tournament.breaks[key];
            tournamentBreak["id"] = key;
            tournamentBreak["isBreak"] = true;
            return tournamentBreak;
          }
        );
        let matchesTemp = [];

        matchesTemp = matchesCopy.concat(
          Object.keys(breaksCopy).map((key) => breaksCopy[key])
        );

        this.setState({
          matchesTemp: matchesTemp,
        });

        if (this.props.tournament.ia) {
          batch.set(db.collection("cacheUpdatesApp").doc(), {
            tournamentId: this.props.tournament[".key"],
            status: "pending",
            timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
          });
        }

        batch.commit().catch((error) => {
          console.log(error.message);
          this.setState({ matchesTemp: undefined });
        });
      } else {
        return;
      }
    } else if (result.type === "FIELD") {
      if (!result.destination) {
        return;
      }

      let fields = Object.keys(this.props.tournament.fields || {})
        .filter((key) => {
          let field = this.props.tournament.fields[key];
          let showField = false;
          if (this.state.selectedSportPark === "0") {
            if (field.sportPark === undefined || field.sportPark === "0") {
              showField = true;
            }
          } else {
            if (field.sportPark === this.state.selectedSportPark) {
              showField = true;
            }
          }
          return showField;
        })
        .sort((aKey, bKey) => {
          let a = this.props.tournament.fields[aKey];
          let b = this.props.tournament.fields[bKey];
          if (a.num > b.num) {
            return 1;
          } else if (a.num < b.num) {
            return -1;
          } else {
            return aKey - bKey;
          }
        })
        .slice();
      const [removed] = fields.splice(result.source.index, 1);
      fields.splice(result.destination.index, 0, removed);

      const db = window.firebase.firestore();
      let batch = db.batch();
      const tournamentRef = db
        .collection("tournaments")
        .doc(this.props.tournament[".key"]);

      let fieldsTemp = this.props.tournament.fields;

      fields.forEach((f, i) => {
        let field = this.props.tournament.fields[f];
        field["num"] = i;
        fieldsTemp[f] = field;
      });

      batch.update(tournamentRef, { fields: fieldsTemp });
      this.setState({ fieldsTemp: fieldsTemp });

      if (this.props.tournament.ia) {
        batch.set(db.collection("cacheUpdatesApp").doc(), {
          tournamentId: this.props.tournament[".key"],
          status: "pending",
          timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
        });
      }

      batch
        .commit()
        .then(() => {
          this.setState({ fieldsTemp: undefined });
        })
        .catch((error) => {
          console.log(error.message);
          this.setState({ fieldsTemp: undefined });
        });
    } else {
      let matchElement = document.getElementById(result.draggableId + "id");
      // dropped outside a field
      if (
        !result.destination ||
        (result.destination.droppableId === "emptyDrop" &&
          result.source.droppableId === "empty")
      ) {
        return;
      }

      if ((this.props.tournamentStatus || {}).closed) {
        this.toggleFinishedDialog();
        matchElement.style.background = "";
        matchElement.style.boxShadow = "";
      } else {
        let matches = [];
        for (let m in this.state.matches) {
          const match = this.state.matches[m];
          const poule = this.state.poulesByKey[match.poule] || {};
          if (poule.losersFinal) {
            const bracket = this.state.bracketsByKey[poule.bracket] || {};
            if (bracket.showLosersFinal) {
              matches.push(match);
            }
          } else {
            matches.push(match);
          }
        }

        let sourceField = result.source.droppableId;
        const sourceIndex = result.source.index;
        let destinationField = result.destination.droppableId;
        const destinationIndex = result.destination.index;
        let sourceDay = this.state.selectedDay;
        let destinationDay = this.state.selectedDay;

        if (destinationField === "emptyDrop") {
          destinationField = null;
          destinationDay = "0";
        }

        if (sourceField === "empty") {
          sourceField = null;
          sourceDay = "0";
        }

        let sourceBreaks = Object.keys(this.props.tournament.breaks || {})
          .map((key, i) => {
            let tournamentBreak = this.props.tournament.breaks[key];
            tournamentBreak["id"] = key;
            tournamentBreak["isBreak"] = true;
            return tournamentBreak;
          })
          .filter(
            (tBreak) => tBreak.field === sourceField && tBreak.day === sourceDay
          );

        let destinationBreaks = Object.keys(this.props.tournament.breaks || {})
          .map((key, i) => {
            let tournamentBreak = this.props.tournament.breaks[key];
            tournamentBreak["id"] = key;
            tournamentBreak["isBreak"] = true;
            return tournamentBreak;
          })
          .filter(
            (tBreak) =>
              tBreak.field === destinationField && tBreak.day === destinationDay
          );

        let sourceMatches = [];

        if (sourceField === null) {
          sourceMatches = matches
            .filter((match) => {
              if (this.state.selected.length > 0) {
                let matchSelected = false;
                let selectedKeys = this.state.selected.map((s) => s.value);

                if (selectedKeys.indexOf(match.poule) > -1) {
                  matchSelected = true;
                  let showSelectRounds = false;
                  if (this.state.selected.length === 1) {
                    this.state.selected.forEach((s) => {
                      if (s.isPoule) {
                        showSelectRounds = true;
                      }
                    });
                  }
                  if (showSelectRounds) {
                    if (
                      this.state.selectedRoundFilter !== "all" &&
                      match.round !== this.state.selectedRoundFilter
                    ) {
                      matchSelected = false;
                    }
                  }
                } else {
                  let poule = this.state.poulesByKey[match.poule] || {};
                  if (selectedKeys.indexOf(poule.division) > -1) {
                    matchSelected = true;
                  } else if (poule.bracket) {
                    if (selectedKeys.indexOf(poule.bracket) > -1) {
                      matchSelected = true;
                    }
                  }
                }
                return (
                  (match.field === sourceField || match.field === "empty") &&
                  matchSelected
                );
              } else {
                return match.field === sourceField || match.field === "empty";
              }
            })
            .filter((match) => {
              // Apply team search filtering
              const searchTerm = this.state.teamSearch.toLowerCase();
              if (!searchTerm) return true;

              const team1 = getTeamName(
                match,
                this.state.poulesByKey,
                this.state.teamsByKey,
                this.state.teams,
                this.state.resultSpotsAll,
                this.props.divisionsObject,
                this.state.bracketsByKey,
                1
              );

              const team2 = getTeamName(
                match,
                this.state.poulesByKey,
                this.state.teamsByKey,
                this.state.teams,
                this.state.resultSpotsAll,
                this.props.divisionsObject,
                this.state.bracketsByKey,
                2
              );

              return (
                team1.toLowerCase().includes(searchTerm) ||
                team2.toLowerCase().includes(searchTerm)
              );
            })
            .concat(this.state.selected.length > 0 ? [] : sourceBreaks)
            .sort((a, b) => {
              let aBracket = undefined;
              let aPoule = this.state.poulesByKey[a.poule] || {};
              if (aPoule.bracket) {
                aBracket = this.state.bracketsByKey[aPoule.bracket] || {};
              }

              let bBracket = undefined;
              let bPoule = this.state.poulesByKey[b.poule] || {};
              if (bPoule.bracket) {
                bBracket = this.state.bracketsByKey[bPoule.bracket] || {};
              }
              if (
                (aBracket || aPoule || {}).division >
                (bBracket || bPoule || {}).division
              ) {
                return 1;
              } else if (
                (aBracket || aPoule || {}).division <
                (bBracket || bPoule || {}).division
              ) {
                return -1;
              } else if (
                (aBracket || aPoule || {}).fase >
                (bBracket || bPoule || {}).fase
              ) {
                return 1;
              } else if (
                (aBracket || aPoule || {}).fase <
                (bBracket || bPoule || {}).fase
              ) {
                return -1;
              } else if (
                (aBracket || aPoule || {}).indexNum >
                (bBracket || bPoule || {}).indexNum
              ) {
                return 1;
              } else if (
                (aBracket || aPoule || {}).indexNum <
                (bBracket || bPoule || {}).indexNum
              ) {
                return -1;
              } else if (
                (aBracket || aPoule || {}).num > (bBracket || bPoule || {}).num
              ) {
                return 1;
              } else if (
                (aBracket || aPoule || {}).num < (bBracket || bPoule || {}).num
              ) {
                return -1;
              } else {
                return (
                  (aPoule.bracket ? aPoule.num : a.numInPoule) -
                  (bPoule.bracket ? bPoule.num : b.numInPoule)
                );
              }
            });
        } else {
          sourceMatches = matches
            .filter(
              (match) => match.field === sourceField && match.day === sourceDay
            )
            .concat(sourceBreaks)
            .sort((a, b) => {
              if (a.numInField > b.numInField) {
                return 1;
              } else if (a.numInField < b.numInField) {
                return -1;
              } else if (
                (this.state.poulesByKey[a.poule] || {}).indexNum >
                (this.state.poulesByKey[b.poule] || {}).indexNum
              ) {
                return 1;
              } else if (
                (this.state.poulesByKey[a.poule] || {}).indexNum <
                (this.state.poulesByKey[b.poule] || {}).indexNum
              ) {
                return -1;
              } else {
                return (
                  (this.state.poulesByKey[a.poule] || {}).num -
                  (this.state.poulesByKey[b.poule] || {}).num
                );
              }
            });
        }

        let destinationMatches = matches
          .filter(
            (match) =>
              match.field === destinationField && match.day === destinationDay
          )
          .concat(destinationBreaks)
          .sort((a, b) => a.numInField - b.numInField);

        let [moved] = sourceMatches.splice(sourceIndex, 1);

        if (sourceField === destinationField) {
          [moved] = destinationMatches.splice(sourceIndex, 1);
        }

        let pouleForMoved = this.state.poulesByKey[moved.poule] || {};
        let hideMatch = false;
        if (pouleForMoved["status" + moved.team1]) {
          hideMatch = true;
        }
        if (pouleForMoved["status" + moved.team2]) {
          hideMatch = true;
        }
        matchElement.style.background = hideMatch ? "#f5f5f5" : "";
        matchElement.style.boxShadow = "";

        destinationMatches.splice(destinationIndex, 0, moved);
        const db = window.firebase.firestore();
        let batch = db.batch();
        const matchesRef = db
          .collection("tournaments")
          .doc(this.props.tournament[".key"])
          .collection("matches");

        if (moved.isBreak) {
          let toUpdate = {};
          if (!moved.isEvent && destinationField === null) {
            toUpdate[`breaks.${moved.id}`] =
              window.firebase.firestore.FieldValue.delete();
          } else {
            toUpdate[`breaks.${moved.id}.field`] = destinationField;
            toUpdate[`breaks.${moved.id}.day`] = destinationDay;
          }
          if (moved.isEvent && destinationField === null) {
            toUpdate[`breaks.${moved.id}.st`] = "";
            toUpdate[`breaks.${moved.id}.et`] = "";
          }
          batch.update(
            db.collection("tournaments").doc(this.props.tournament[".key"]),
            toUpdate
          );
        } else {
          let toUpdate = {
            field: destinationField,
            day: destinationDay,
          };
          if (destinationField === null) {
            toUpdate["referee"] = "";
            toUpdate["referee2"] = "";
            toUpdate["referee3"] = "";
            toUpdate["referee4"] = "";
            toUpdate["referee5"] = "";
            toUpdate["st"] = "";
            toUpdate["et"] = "";
            toUpdate["duration"] = null;
          }
          batch.update(matchesRef.doc(moved.id), toUpdate);
        }

        let matchesCopy = this.state.matchesByKey;
        if (!moved.isBreak) {
          matchesCopy[moved.id]["field"] = destinationField;
          matchesCopy[moved.id]["day"] = destinationDay;
        }

        let breaksCopy = this.props.tournament.breaks || {};
        if (moved.isBreak) {
          breaksCopy[moved.id]["field"] = destinationField;
          breaksCopy[moved.id]["day"] = destinationDay;
        }

        if (destinationField !== null) {
          let field =
            (this.props.tournament.fields || {})[destinationField] || {};
          let startTimestamp = field.startTime;
          if (destinationDay !== "0") {
            startTimestamp = field[destinationDay] || field.startTime;
          }
          for (let i in destinationMatches) {
            const match = destinationMatches[i];
            const startTime = moment
              .unix(startTimestamp)
              .tz(this.props.tournament.timezone || "Europe/Amsterdam")
              .format("HH:mm");
            const endTime = moment
              .unix(
                startTimestamp +
                  getMatchDuration(
                    this.props.tournament,
                    this.state.poulesByKey,
                    match
                  ) *
                    60
              )
              .tz(this.props.tournament.timezone || "Europe/Amsterdam")
              .format("HH:mm");
            if (match.isBreak) {
              startTimestamp += Number(match.duration || 0) * 60;
              let toUpdate = {};
              toUpdate[`breaks.${match.id}.numInField`] = Number(i);
              toUpdate[`breaks.${match.id}.st`] = startTime;
              toUpdate[`breaks.${match.id}.et`] = endTime;
              batch.update(
                db.collection("tournaments").doc(this.props.tournament[".key"]),
                toUpdate
              );
              breaksCopy[match.id]["numInField"] = Number(i);
              breaksCopy[match.id]["st"] = startTime;
              breaksCopy[match.id]["et"] = endTime;
            } else {
              startTimestamp +=
                getMatchDuration(
                  this.props.tournament,
                  this.state.poulesByKey,
                  match
                ) * 60;
              startTimestamp +=
                (this.props.tournament.timeBetweenMatches !== undefined
                  ? this.props.tournament.timeBetweenMatches
                  : defaultMatchTimes.timeBetweenMatches) * 60;
              batch.update(matchesRef.doc(match.id), {
                numInField: Number(i),
                st: startTime,
                et: endTime,
              });
              matchesCopy[match.id]["numInField"] = Number(i);
              matchesCopy[match.id]["st"] = startTime;
              matchesCopy[match.id]["et"] = endTime;
            }
          }
        }
        if (sourceField !== null && sourceField !== destinationField) {
          let field = (this.props.tournament.fields || {})[sourceField] || {};
          let startTimestamp = field.startTime;
          if (destinationDay !== "0") {
            startTimestamp = field[sourceDay] || field.startTime;
          }
          for (let i in sourceMatches) {
            const match = sourceMatches[i];
            const startTime = moment
              .unix(startTimestamp)
              .tz(this.props.tournament.timezone || "Europe/Amsterdam")
              .format("HH:mm");
            const endTime = moment
              .unix(
                startTimestamp +
                  getMatchDuration(
                    this.props.tournament,
                    this.state.poulesByKey,
                    match
                  ) *
                    60
              )
              .tz(this.props.tournament.timezone || "Europe/Amsterdam")
              .format("HH:mm");
            if (match.isBreak) {
              startTimestamp += Number(match.duration || 0) * 60;
              let toUpdate = {};
              toUpdate[`breaks.${match.id}.numInField`] = Number(i);
              toUpdate[`breaks.${match.id}.st`] = startTime;
              toUpdate[`breaks.${match.id}.et`] = endTime;
              batch.update(
                db.collection("tournaments").doc(this.props.tournament[".key"]),
                toUpdate
              );
              breaksCopy[match.id]["numInField"] = Number(i);
              breaksCopy[match.id]["st"] = startTime;
              breaksCopy[match.id]["et"] = endTime;
            } else {
              startTimestamp +=
                getMatchDuration(
                  this.props.tournament,
                  this.state.poulesByKey,
                  match
                ) * 60;
              startTimestamp +=
                (this.props.tournament.timeBetweenMatches !== undefined
                  ? this.props.tournament.timeBetweenMatches
                  : defaultMatchTimes.timeBetweenMatches) * 60;
              batch.update(matchesRef.doc(match.id), {
                numInField: Number(i),
                st: startTime,
                et: endTime,
              });
              matchesCopy[match.id]["numInField"] = Number(i);
              matchesCopy[match.id]["st"] = startTime;
              matchesCopy[match.id]["et"] = endTime;
            }
          }
        }

        let matchesTemp = [];

        Object.keys(matchesCopy).forEach((key) => {
          let match = matchesCopy[key];
          const poule = this.state.poulesByKey[match.poule] || {};
          if (poule.losersFinal) {
            const bracket = this.state.bracketsByKey[poule.bracket] || {};
            if (bracket.showLosersFinal) {
              matchesTemp.push(match);
            }
          } else {
            matchesTemp.push(match);
          }
        });

        matchesTemp = matchesTemp.concat(
          Object.keys(breaksCopy).map((key) => breaksCopy[key])
        );

        this.setState({
          matchesTemp: matchesTemp,
        });

        if (this.props.tournament.ia) {
          batch.set(db.collection("cacheUpdatesApp").doc(), {
            tournamentId: this.props.tournament[".key"],
            status: "pending",
            timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
          });
        }
        batch
          .commit()
          .catch((error) => {
            console.log(error.message);
            this.setState({ matchesTemp: undefined });
          })
          .then(() => {
            if (moved.isBreak) {
              if (this.state.matchesTemp !== undefined) {
                this.setState({ matchesTemp: undefined });
              }
            }
          });
      }
    }
  };

  onDragStart = (start) => {
    if (start.type === "REFEREE") {
      let refereeId = start.draggableId.slice(0, 20);
      let referee = this.state.refereesByKey[refereeId];
      let numMatches = this.state.matches.filter(
        (m) =>
          m.referee === refereeId ||
          m.referee2 === refereeId ||
          m.referee3 === refereeId ||
          m.referee4 === refereeId ||
          m.referee5 === refereeId
      ).length;
      if (start.source.droppableId !== "referees") {
        numMatches--;
      }
      let maxMatchesWish = checkRefereeWishMaxMatches(referee, numMatches);
      this.setState({
        isDraggingRefereeFromMatch: start.source.droppableId,
        isDraggingReferee: refereeId,
        isDraggingRefereeMaxMatchesWish: maxMatchesWish,
      });

      let refereeElements = document.getElementsByClassName(
        "teamElementId" + start.draggableId.slice(0, 20)
      );
      for (var i = 0; i < refereeElements.length; i++) {
        let element = refereeElements[i];
        element.style.fontWeight = "bold";
      }
    }
    let match = this.state.matchesByKey[start.draggableId];
    let tournamentBreak = (this.props.tournament.breaks || {})[
      start.draggableId
    ];
    if (tournamentBreak) {
      (tournamentBreak.teams || []).forEach((tId) => {
        let teamElements = document.getElementsByClassName(
          "teamElementId" + tId
        );
        for (var i = 0; i < teamElements.length; i++) {
          let element = teamElements[i];
          element.style.fontWeight = "bold";
        }
      });
    }
    if (match) {
      let teamElements = document.getElementsByClassName(
        "bothTeamElement" + match.poule
      );
      let team1Element = document.getElementById(start.draggableId + "0");
      let team2Element = document.getElementById(start.draggableId + "1");
      let team1 = team1Element.textContent;
      let team2 = team2Element.textContent;

      let team1Id = null;
      if (team1Element.className) {
        let classNames = team1Element.className.split(" ");
        if (classNames[2]) {
          team1Id = classNames[2];
        }
      }
      let team2Id = null;
      if (team2Element.className) {
        let classNames = team2Element.className.split(" ");
        if (classNames[2]) {
          team2Id = classNames[2];
        }
      }

      if (team1Id) {
        let elements = document.getElementsByClassName(team1Id);
        for (let i = 0; i < elements.length; i++) {
          let element = elements[i];
          element.style.fontWeight = "bold";
        }
      }

      if (team2Id) {
        let elements = document.getElementsByClassName(team2Id);
        for (let i = 0; i < elements.length; i++) {
          let element = elements[i];
          element.style.fontWeight = "bold";
          element.style.textDecoration = "underline";
        }
      }

      for (var x = 0; x < teamElements.length; x++) {
        let element = teamElements[x];
        if (element.textContent === team1) {
          element.style.fontWeight = "bold";
        } else if (element.textContent === team2) {
          element.style.fontWeight = "bold";
          element.style.textDecoration = "underline";
        }
      }
    }

    if (match || tournamentBreak) {
      let hideMatch = false;
      if (match) {
        let poule = this.state.poulesByKey[match.poule] || {};
        if (poule["status" + match.team1]) {
          hideMatch = true;
        }
        if (poule["status" + match.team2]) {
          hideMatch = true;
        }
      }
      let matchElement = document.getElementById(start.draggableId + "id");
      matchElement.style.background = hideMatch ? "#f5f5f5" : "white";
      matchElement.style.boxShadow = "0 2px 3px #b3b3b3, 0 2px 10px #1a1a1a";
    }
  };

  render() {
    let resetMatchesEnabled = false;
    let matchesWithReferees = [];
    let matches = [];
    for (let m in this.state.matches) {
      const match = this.state.matches[m];
      const poule = this.state.poulesByKey[match.poule];
      if (poule !== undefined) {
        if (match.field !== null && match.field !== "empty") {
          resetMatchesEnabled = true;
        }
        if (
          match.referee ||
          match.referee2 ||
          match.referee3 ||
          match.referee4 ||
          match.referee5
        ) {
          matchesWithReferees.push(match.id);
        }
        if (poule.losersFinal) {
          const bracket = this.state.bracketsByKey[poule.bracket] || {};
          if (bracket.showLosersFinal) {
            matches.push(match);
          }
        } else {
          matches.push(match);
        }
      }
    }

    // START CODE FOR EXPORT CONTAINER. TODO: IMPROVE SO NO DUPLICATE
    let breaks = Object.keys(this.props.tournament.breaks || {}).map(
      (key, i) => {
        let tournamentBreak = this.props.tournament.breaks[key];
        if (
          tournamentBreak.field !== null &&
          tournamentBreak.field !== "empty"
        ) {
          resetMatchesEnabled = true;
        }
        tournamentBreak["id"] = key;
        tournamentBreak["isBreak"] = true;
        return tournamentBreak;
      }
    );
    let allMatches = matches.concat(breaks);
    // matches per day
    let matchesPerDay = groupBy(allMatches, "day");
    for (let d in matchesPerDay) {
      let matchesForDay = matchesPerDay[d];
      let matchesPerField = groupBy(matchesForDay, "field");
      let matchesWithTime = [];
      for (let fieldKey in matchesPerField) {
        if (
          fieldKey !== "null" &&
          (this.props.tournament.fields || {})[fieldKey]
        ) {
          let field = this.props.tournament.fields[fieldKey];
          let startTimestamp = field.startTime;
          if (d !== "0") {
            startTimestamp = field[d] || field.startTime;
          }
          let fieldMatches = matchesPerField[fieldKey];
          fieldMatches.sort((a, b) => {
            if (Number(a.numInField) > Number(b.numInField)) {
              return 1;
            } else if (Number(a.numInField) < Number(b.numInField)) {
              return -1;
            } else {
              return 0;
            }
          });
          for (let m in fieldMatches) {
            let match = fieldMatches[m];
            const startTime = moment.unix(startTimestamp).format("HH:mm");
            const endTime = moment
              .unix(
                startTimestamp +
                  getMatchDuration(
                    this.props.tournament,
                    this.state.poulesByKey,
                    match
                  ) *
                    60
              )
              .format("HH:mm");
            if (match.isBreak) {
              startTimestamp += Number(match.duration || 0) * 60;
              if (match.isEvent) {
                match["startTime"] = startTime;
                match["endTime"] = endTime;
              }
            } else {
              startTimestamp +=
                getMatchDuration(
                  this.props.tournament,
                  this.state.poulesByKey,
                  match
                ) * 60;
              startTimestamp +=
                (this.props.tournament.timeBetweenMatches !== undefined
                  ? this.props.tournament.timeBetweenMatches
                  : defaultMatchTimes.timeBetweenMatches) * 60;
            }
            match["startTime"] = startTime;
            match["endTime"] = endTime;
            if (!match.isBreak || match.isEvent) {
              if (!match.isBreak && !match.isEvent) {
                const poule = this.state.poulesByKey[match.poule];
                let hideMatch = false;
                if (poule["status" + match.team1]) {
                  hideMatch = true;
                }
                if (poule["status" + match.team2]) {
                  hideMatch = true;
                }
                if (!hideMatch) {
                  matchesWithTime.push(match);
                }
              } else {
                matchesWithTime.push(match);
              }
            }
          }
        }
      }
      matchesPerDay[d] = matchesWithTime;
    }

    let filteredMatchesPerDay = {};
    for (let d in matchesPerDay) {
      if (matchesPerDay[d].length > 0) {
        filteredMatchesPerDay[d] = matchesPerDay[d];
      }
    }
    matchesPerDay = filteredMatchesPerDay;
    // END CODE FOR EXPORT CONTAINER

    let divisionColors = {};
    this.props.divisions.forEach((division, i) => {
      divisionColors[division.id] = ColorsDivisions[i % 25];
    });
    let groupColors = {};
    let groups = [];
    Object.keys(this.state.poulesByKey).forEach((key) => {
      let poule = this.state.poulesByKey[key];
      if (!poule.bracket) {
        groups.push(key);
      }
    });

    Object.keys(this.state.bracketsByKey).forEach((key) => {
      groups.push(key);
    });

    groups.forEach((group, i) => {
      groupColors[group] = ColorsGroups[i % 50];
    });

    let eventOptions = [
      {
        value: "all",
        label: languages.schedule.all,
      },
    ]
      .concat(this.state.teams)
      .sort((a, b) => {
        if (a.division > b.division) {
          return 1;
        } else if (a.division < b.division) {
          return -1;
        } else {
          function chunkify(t) {
            var tz = [],
              x = 0,
              y = -1,
              n = 0,
              i,
              j;

            while ((i = (j = t.charAt(x++)).charCodeAt(0))) {
              // eslint-disable-next-line
              var m = i == 46 || (i >= 48 && i <= 57);
              if (m !== n) {
                tz[++y] = "";
                n = m;
              }
              tz[y] += j;
            }
            return tz;
          }

          let toChunkA = a["name"] || "";
          let toChunkB = b["name"] || "";

          var aa = chunkify(toChunkA.toString().toLowerCase());
          var bb = chunkify(toChunkB.toString().toLowerCase());

          for (let x = 0; aa[x] && bb[x]; x++) {
            if (aa[x] !== bb[x]) {
              var c = Number(aa[x]),
                d = Number(bb[x]);
              // eslint-disable-next-line
              if (c == aa[x] && d == bb[x]) {
                return c - d;
              } else return aa[x] > bb[x] ? 1 : -1;
            }
          }
          return aa.length - bb.length;
        }
      });
    return this.state.matchesLoaded &&
      this.state.poulesLoaded &&
      this.state.bracketsLoaded &&
      this.state.resultSpotsLoaded &&
      this.state.refereesLoaded &&
      this.state.daysLoaded &&
      this.state.sportParksLoaded &&
      this.state.teamsLoaded &&
      (this.props.tournamentAdmin === undefined ||
        this.props.tournamentAdmin.manageSchedule) ? (
      <DragDropContext
        onDragStart={this.onDragStart}
        onDragEnd={this.onDragEnd}
      >
        <UpgradeDialog
          open={this.state.upgradeDialogOpen}
          toggleDialog={this.toggleUpgradeDialog}
          title={languages.upgrade.upgradeTournament}
          description={languages.upgrade.upgradeText1}
          tournament={this.props.tournament}
          user={this.props.user}
          userData={this.props.userData}
          tournamentStatus={this.props.tournamentStatus}
        />
        <FinishedDialog
          open={this.state.finishedDialogOpen}
          handleClose={this.toggleFinishedDialog}
        />
        <Schedule
          tournament={this.props.tournament}
          divisions={this.props.divisions}
          divisionsObject={this.props.divisionsObject}
          matches={matches}
          matchesPerDay={matchesPerDay}
          matchesByKey={this.state.matchesByKey}
          matchesLoaded={this.state.matchesLoaded}
          pouleOptions={this.state.pouleOptions}
          bracketsByKey={this.state.bracketsByKey}
          bracketPoules={this.state.bracketPoules}
          bracketOptions={this.state.bracketOptions}
          poulesByKey={this.state.poulesByKey}
          poulesLoaded={this.state.poulesLoaded}
          resultSpotsAll={this.state.resultSpotsAll}
          resultSpotsLoaded={this.state.resultSpotsLoaded}
          matchesTemp={this.state.matchesTemp}
          referees={this.state.referees}
          refereesByKey={this.state.refereesByKey}
          refereesLoaded={this.state.refereesLoaded}
          selectedDay={this.state.selectedDay}
          selectDay={this.selectDay}
          days={this.state.days}
          daysByKey={this.state.daysByKey}
          tournamentStatus={this.props.tournamentStatus}
          toggleFinishedDialog={this.toggleFinishedDialog}
          sportParks={this.state.sportParks}
          sportParksByKey={this.state.sportParksByKey}
          selectedSportPark={this.state.selectedSportPark}
          selectSportPark={this.selectSportPark}
          selected={this.state.selected}
          handleSelectChangeNotPlanned={this.handleSelectChange}
          divisionColors={divisionColors}
          groupColors={groupColors}
          allPoules={this.state.allPoules}
          fieldsTemp={this.state.fieldsTemp}
          isDraggingRefereeFromMatch={this.state.isDraggingRefereeFromMatch}
          isDraggingReferee={this.state.isDraggingReferee}
          matchesWithReferees={matchesWithReferees}
          handleSideSheetExpandClick={this.handleSideSheetExpandClick}
          sideSheetExpanded={this.state.sideSheetExpanded}
          sideSheetExpandedMobile={this.state.sideSheetExpandedMobile}
          supportOpen={this.props.supportOpen}
          isDraggingRefereeMaxMatchesWish={
            this.state.isDraggingRefereeMaxMatchesWish
          }
          teams={this.state.teams}
          teamsByKey={this.state.teamsByKey}
          players={this.state.players}
          eventOptions={eventOptions}
          userData={this.props.userData}
          resetMatchesEnabled={resetMatchesEnabled}
          user={this.props.user}
          userStatus={this.props.userStatus}
          toggleUpgradeDialog={this.toggleUpgradeDialog}
          selectedRoundFilter={this.state.selectedRoundFilter}
          handleSelectRoundChange={this.handleSelectRoundChange}
          teamSearch={this.state.teamSearch}
          handleTeamSearch={this.handleTeamSearch}
        />
      </DragDropContext>
    ) : (
      <div
        style={{
          width: "100%",
          textAlign: "center",
          paddingTop: 20,
          height: 177,
        }}
      >
        {this.state.oneSecondPassed && <CircularProgress />}
      </div>
    );
  }
}

export default ScheduleContainer;
